import { Mesh } from 'three';
import React from 'react';

const defaultFontSize = 12;

export default {
    name: 'circle-pointer',
    prototype: 'items',

    info: {
        tag: ['circle-pointer'],
        title: 'Circle Pointer',
        description: 'Circle Pointer',
        image: require('./circle-pointer.png')
    },

    properties: {
        text: {
            label: 'text',
            type: 'string',
            defaultValue: '1'
        },
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 75
            }
        },
        flip_orizzontal: {
            label: 'flip orizzontale',
            type: 'checkbox',
            defaultValue: false,
            values: {
                'none': false,
                'yes': true
            }
        },
    },

    render2D: function (element, layer, scene) {
        let text = element.properties.get('text') || '';
        let flip = element.properties.get('flip_orizzontal');

        let width = element.properties.get('width').get('length');

        if (flip === false) {
            return (
                <g transform={`scale(${width * 0.02} ${width * 0.02}) translate(12, 0)`}>
                    <path id="1" d="M0 0 L19 -25" style={{ stroke: '#000000' }} />
                    <path id="2" d="M19 -25 L26 -25" style={{ stroke: '#000000' }} />
                    <circle id="3" cx="36" cy="-25" r="10" style={{ stroke: '#000000', fill: '#ffffff' }} />
                    <text
                        x="36"
                        y="26"
                        fontFamily="Arial"
                        alignmentBaseline="middle"
                        textAnchor="middle"
                        fontSize={defaultFontSize}
                        fill="#000000"
                        transform={'scale(1,-1)'}
                    >
                        {text}
                    </text>
                </g>
            )
        } else {
            return (
                <g transform={`scale(${width * 0.02} ${width * 0.02}) translate(12, 0)`}>
                    <path id="1" d="M0 0 L-19 -25" style={{ stroke: '#000000' }} />
                    <path id="2" d="M-19 -25 L-26 -25" style={{ stroke: '#000000' }} />
                    <circle id="3" cx="-36" cy="-25" r="10" style={{ stroke: '#000000', fill: '#ffffff' }} />
                    <text
                        x="-36"
                        y="26"
                        fontFamily="Arial"
                        alignmentBaseline="middle"
                        textAnchor="middle"
                        fontSize={defaultFontSize}
                        fill="#000000"
                        transform={'scale(1,-1)'}
                    >
                        {text}
                    </text>
                </g>
            )
        }
    },

    render3D: function (element, layer, scene) {
        let mesh = new Mesh();
        return Promise.resolve(mesh);
    }
};
